import { ExperienceItem, MediaItem, Patent, Project } from './types';

export const SOCIAL_LINKS = {
  linkedin: "https://www.linkedin.com/in/jaclynkonzelmann/",
  twitter: "https://x.com/jacalulu",
  substack: "https://blog.jaclynkonzelmann.com/",
  talks: "https://talks.jaclynkonzelmann.com/",
  sideProjects: "/side-projects/",
  pettingZoo: "/side-projects/sunny-meadow-petting-zoo/",
  instagram: "https://www.instagram.com/jaclyn_konzelmann/",
  nanoBanana: "https://drive.google.com/file/d/1t7jVJ5PgKMxjV1TEqGi4bWLzLl-sN2z5/view"
};

export const PROFILE_IMAGES = [
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/photo-profile.jpeg",
    style: "Photography"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/ink-profile.png",
    style: "Ink Illustration"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/acrylic-profile.png",
    style: "Acrylic Painting"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Watercolor-profile.png",
    style: "Watercolor Painting"
  }
];

export const SPEAKING_IMAGES = [
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/io.jpg",
    alt: "Jaclyn Konzelmann speaking at Google I/O"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/keynote1.jpg",
    alt: "Jaclyn Konzelmann giving a keynote on AI products (photo 1)"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/keynote2.jpg",
    alt: "Jaclyn Konzelmann giving a keynote on AI products (photo 2)"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/keynote3.jpg",
    alt: "Jaclyn Konzelmann giving a keynote on AI products (photo 3)"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/keynote4.jpg",
    alt: "Jaclyn Konzelmann giving a keynote on AI products (photo 4)"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/keynote5.jpg",
    alt: "Jaclyn Konzelmann giving a keynote on AI products (photo 5)"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/keynote6.jpg",
    alt: "Jaclyn Konzelmann giving a keynote on AI products (photo 6)"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/keynote7.jpeg",
    alt: "Jaclyn Konzelmann giving a keynote on AI products (photo 7)"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/keynote8.jpeg",
    alt: "Jaclyn Konzelmann giving a keynote on AI products (photo 8)"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/keynote9.jpeg",
    alt: "Jaclyn Konzelmann giving a keynote on AI products (photo 9)"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/Google%20for%20Startups%20Group.jpg",
    alt: "Jaclyn Konzelmann with the Google for Startups group"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/google-for-startups-stage.jpg",
    alt: "Jaclyn Konzelmann presenting on stage at a Google for Startups event"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/Pomelli%20Demo.jpg",
    alt: "Jaclyn Konzelmann demoing Pomelli, Google Labs' AI marketing tool"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/Interview.jpg",
    alt: "Jaclyn Konzelmann being interviewed about AI and product"
  },
  {
    url: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Speaking-Events/Pomelli.jpg",
    alt: "Jaclyn Konzelmann presenting Pomelli at Google Labs"
  }
];

export interface ProjectWithLinks extends Project {
  announcementUrl?: string;
}

export const PROJECTS: ProjectWithLinks[] = [
  {
    title: "Pomelli",
    category: ["SMB", "Content Gen"],
    description: "Easily generate on-brand content for your business.",
    imageUrl: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Pomelli.png",
    link: "https://labs.google.com/pomelli/about/",
    announcementUrl: "https://blog.google/technology/google-labs/pomelli/"
  },
  {
    title: "Opal",
    category: ["AI Tools", "Productivity"],
    description: "Describe, create, and share your AI mini-apps and automate workflows with ease.",
    imageUrl: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Opal.png",
    link: "https://opal.google/landing/",
    announcementUrl: "https://developers.googleblog.com/en/introducing-opal/"
  },
  {
    title: "Mixboard",
    category: ["Creativity", "Visualization"],
    description: "A new way to visualize your ideas from Google Labs. Combining creativity with AI for infinite canvas brainstorming.",
    imageUrl: "https://nak6zodeu71fcbzi.public.blob.vercel-storage.com/Mixboard.png",
    link: "https://labs.google.com/mixboard/welcome",
    announcementUrl: "https://blog.google/technology/google-labs/mixboard/"
  }
];

export const SECONDARY_PROJECTS: ProjectWithLinks[] = [
  {
    title: "Project Mariner",
    category: ["AI Agents", "Future Tech"],
    description: "Exploring the future of human-agent interactions. An AI agent that uses the web for you.",
    imageUrl: "",
    link: "https://www.youtube.com/watch?v=2XJqLPqHtyo"
  },
  {
    title: "Google AI Studio & Gemini API",
    category: ["Developer Tools", "API"],
    description: "Making Google's most capable models accessible to developers and enterprises.",
    imageUrl: "",
    link: "https://developers.googleblog.com/gemini-15-our-next-generation-model-now-available-for-private-preview-in-google-ai-studio/"
  }
];

export const MEDIA: MediaItem[] = [
  {
    type: 'Podcast',
    title: "AI & The Future of Product Management",
    source: "Growth Podcast",
    links: [
      { platform: 'YouTube', url: 'https://www.youtube.com/watch?v=rcz39Y0qFxw' },
      { platform: 'Spotify', url: 'https://open.spotify.com' }
    ],
    note: "Must Listen"
  },
  {
    type: 'Video',
    title: "Keynote: Launching Google AI Studio",
    source: "Google I/O",
    links: [{ platform: 'YouTube', url: 'https://www.youtube.com/live/ddcZnW1HKUY?si=qk1wk2DCIPTJbGN2&t=280' }]
  },
  {
    type: 'Podcast',
    title: "Google I/O Afterparty: The Future of Human-AI Collaboration, From Veo to Mariner",
    source: "Sequoia Capital",
    links: [{ platform: 'Website', url: 'https://sequoiacap.com/podcast/training-data-google-labs/' }]
  },
  {
    type: 'Video',
    title: "Announcing the Gemini API Developer Competition winners",
    source: "Google for Developers",
    links: [{ platform: 'YouTube', url: 'https://www.youtube.com/watch?v=_cZa_7KaQ3c' }]
  }
];

export const PATENTS: Patent[] = [
  {
    title: "Dynamic and/or context-specific hot words to invoke automated assistant",
    assignee: "Google LLC",
    number: "US 12,272,356",
    date: "Oct 2022",
    status: 'Granted',
    link: "https://patents.google.com/patent/US12272356"
  },
  {
    title: "Methods and systems for reducing latency in automated assistant interactions",
    assignee: "Google LLC",
    number: "US 12,051,416",
    date: "Jul 2024",
    status: 'Granted',
    link: "https://patents.google.com/patent/US12051416"
  },
  {
    title: "Enabling natural conversations with soft endpointing for an automated assistant",
    assignee: "Google LLC",
    number: "US 12,020,703",
    date: "Jun 2024",
    status: 'Granted',
    link: "https://patents.google.com/patent/US12020703"
  },
  {
    title: "Enrollment with an automated assistant",
    assignee: "Google LLC",
    number: "US 11,238,142",
    date: "Feb 2022",
    status: 'Granted',
    link: "https://patents.google.com/patent/US11238142"
  },
  {
    title: "Pinning a callout animation",
    assignee: "Microsoft Technology Licensing, LLC",
    number: "US 10,162,502",
    date: "Dec 2018",
    status: 'Granted',
    link: "https://patents.google.com/patent/US10162502"
  },
  {
    title: "Display screen with user interface (Design Patent)",
    assignee: "Microsoft Corporation",
    number: "US D687,456",
    date: "Aug 2013",
    status: 'Granted',
    link: "https://patents.google.com/patent/USD687456"
  },
  {
    title: "Display screen with graphical user interface (Design Patent)",
    assignee: "Microsoft Corporation",
    number: "US D689,883",
    date: "Sep 2013",
    status: 'Granted',
    link: "https://patents.google.com/patent/USD689883"
  },
  {
    title: "Display screen with graphical user interface (Design Patent)",
    assignee: "Microsoft Corporation",
    number: "US D705,243",
    date: "May 2014",
    status: 'Granted',
    link: "https://patents.google.com/patent/USD705243"
  },
  {
    title: "Regulating assistant responsiveness according to characteristics of a multi-assistant environment",
    assignee: "Google LLC",
    number: "US 2020/0302925 A1",
    date: "Sep 2020",
    status: 'Application',
    link: "https://patents.google.com/patent/US20200302925A1"
  },
  {
    title: "Hot-word free adaptation of automated assistant function(s)",
    assignee: "Google LLC",
    number: "US 2023/0253009 A1",
    date: "Aug 2023",
    status: 'Application',
    link: "https://patents.google.com/patent/US20230253009A1"
  },
  {
    title: "Assigning priority for an automated assistant according to a dynamic user queue",
    assignee: "Google LLC",
    number: "US 2022/0159340 A1",
    date: "May 2022",
    status: 'Application',
    link: "https://patents.google.com/patent/US20220159340A1"
  },
  {
    title: "Generation of natural language (nl) based summaries using a large language model",
    assignee: "Google LLC",
    number: "WO 2024/177662 A1",
    date: "Aug 2024",
    status: 'Application',
    link: "https://patents.google.com/patent/WO2024177662A1"
  }
];

export const EXPERIENCE: ExperienceItem[] = [
  {
    role: "Director of Product Management",
    company: "Google Labs",
    period: "2024 – Present",
    color: "#FF5E7E", // Pink brand color
    description: "Leading multiple teams focused on developing new AI-first products.",
    milestones: [
      {
        date: "DEC 2025",
        title: "Major Updates: Mixboard, Pomelli, Opal",
        description: "Launched Gemini Gems integration and 1-click video ads."
        // generic link removed
      },
      {
        date: "OCT 2025",
        title: "Launched Pomelli",
        description: "Helping SMBs generate on-brand content with AI.",
        link: { label: "Google Keyword Blog", url: "https://blog.google/technology/google-labs/pomelli/" }
      },
      {
        date: "SEP 2025",
        title: "Launched Mixboard",
        description: "A new way to visualize your ideas from Google Labs.",
        link: { label: "Google Keyword Blog", url: "https://blog.google/technology/google-labs/mixboard/" }
      },
      {
        date: "AUG 2025",
        title: "Launched Stax",
        description: "Streamline LLM evaluation with Stax. No more vibe testing.",
        link: { label: "Developer Blog", url: "https://developers.googleblog.com/en/streamline-llm-evaluation-with-stax/" }
      },
      {
        date: "JUL 2025",
        title: "Launched Opal",
        description: "Introduced Opal to help users build and share their own AI mini-apps.",
        link: { label: "Google for Developers", url: "https://developers.googleblog.com/en/introducing-opal/" }
      },
      {
        date: "DEC 2024",
        title: "Launched Project Mariner",
        description: "Initial launch of the AI agent that uses the web for you.",
        link: { label: "Launch Announcement", url: "https://blog.google/technology/google-deepmind/google-gemini-ai-update-december-2024/" }
      }
    ]
  },
  {
    role: "Group Product Manager",
    company: "Google Labs",
    period: "2022 – 2024",
    color: "#FF7235", // Orange brand color
    description: "Specializing in the 0-to-1 stage, having launched Google AI Studio and the Gemini API.",
    milestones: [
      {
        date: "MAY 2024",
        title: "Launched Gemini 1.5 Flash",
        description: "Introduced the fast, lightweight model for high-frequency tasks.",
        link: { label: "Google Keyword Blog", url: "https://blog.google/technology/ai/google-gemini-pro-imagen-duet-ai-update/" }
      },
      {
        date: "APR 2024",
        title: "Gemini Native Audio Understanding",
        description: "Enabled Gemini to process and understand audio directly.",
        link: { label: "Developer Blog", url: "https://developers.googleblog.com/" }
      },
      {
        date: "DEC 2023",
        title: "Launched Google AI Studio",
        description: "The fastest way to build with Gemini models.",
        link: { label: "Google Developer Blog", url: "https://blog.google/technology/ai/google-gemini-ai-update-december-2023/" }
      }
    ]
  },
  {
    role: "Product Manager",
    company: "Google Assistant",
    period: "2017 – 2022",
    color: "#FF5E7E", // Pink again for variety
    description: "Worked on foundational voice and perception features for the global Google Assistant.",
    milestones: [
      {
        date: "2022",
        title: "Quick Phrases",
        description: "Skip the 'Hey Google' for common tasks like answering calls.",
        link: { label: "Keyword Blog", url: "https://blog.google/" }
      },
      {
        date: "2020",
        title: "Voice Filter",
        description: "Advanced speech modeling for noisy environments.",
        link: { label: "Research Blog", url: "https://blog.research.google/" }
      },
      {
        date: "2019",
        title: "Face Match Launch",
        description: "Proactive personalization for the Nest Hub Max.",
        link: { label: "I/O Keynote", url: "https://www.youtube.com/watch?v=yeAu6ZQC0zc" }
      },
      {
        date: "2017",
        title: "Continued Conversation",
        description: "Making human-assistant interactions more natural.",
        link: { label: "I/O 2017", url: "https://blog.google/" }
      }
    ]
  },
  {
    role: "Product Lead",
    company: "Weebly (acquired by Block)",
    period: "2014 – 2017",
    color: "#FF7235",
    description: "Initiated the Weebly App Center and led five product areas including eCommerce and international expansion."
  },
  {
    role: "Co-Founder",
    company: "Amulyte (YC W13)",
    period: "2013 – 2014",
    color: "#FF5E7E",
    description: "Developed a modern emergency response device, participated in Y Combinator, and secured seed funding."
  },
  {
    role: "Program Manager",
    company: "Microsoft Outlook",
    period: "2010 – 2012",
    color: "#FF7235",
    description: "Designed and implemented new features for Outlook, focusing on user experience and interface optimization."
  }
];

export const SHORT_BIO = "Jaclyn Konzelmann is a Director of Product Management at Google Labs, where she leads teams building the next generation of AI-first products. She specializes in the 0-to-1 stage, having launched Google AI Studio and the Gemini API to make Google's most capable models accessible to all. Her current portfolio spans diverse areas, from tools for builders like Stax and Opal, to creative applications like Mixboard and Pomelli, to foundational explorations into the future of human-agent interaction with Project Mariner.";

export const LONG_BIO = `Jaclyn Konzelmann is a Director of Product Management at Google Labs with a passion for building innovative, AI-powered applications from the ground up. At Google for over eight years, she currently leads multiple teams focused on developing new AI-first products. She specializes in taking ideas from concept to launch, a skill exemplified by her leadership in launching the Gemini API and Google AI Studio.

Her current work continues to push the boundaries of AI, with her teams delivering a range of products including Opal for automating workflows and creating AI mini-apps, Mixboard for brainstorming and visualizing ideas, Pomelli for making on-brand content generation accessible to SMBs, and the ambitious Project Mariner initiative, which explores the future of human-agent interaction.

Before joining Google Labs, Jaclyn was a product lead on Google Assistant, where she launched foundational AI-first features built on advanced speech and perception models, including Continued Conversation, Multilingual Assistant, Face Match, and Quick Gestures.

Jaclyn's career has always been centered on product. Prior to Google, she was part of the founding product team at Weebly (now Block), building core e-commerce features and the Weebly App Center. She began her career as a PM at Microsoft, contributing to key user experiences in Outlook, and is also an entrepreneur, having co-founded the Y Combinator-backed hardware startup Amulyte.

Jaclyn holds a degree in Mechatronics Engineering from the University of Waterloo. A recognized voice in the AI space, she holds multiple patents and shares her insights on AI and product strategy through her Substack, 'Thursday Thoughts on AI', and on social media.`;